export const CURRENT_NETWORK_NAME = 'Rinkeby Testnet'
export const CHAIN_ID = 4
export const CONTRACT_ADDRESS_RINKEBY =
  '0xBaEA16eA4C99e500F848D0Dcf9cbDcf611E4F65a'
